import { Center, Grid, GridItem, Image } from "@chakra-ui/react";

import Header from "../../components/Header";

const GALLERY_ITEMS = [
  { id: 0, path: require("../../assets/gallery/1.jpg"), span: 3 },
  {
    id: 1,
    path: require("../../assets/gallery/2.jpg"),
    span: { base: 3, md: 2 },
  },
  {
    id: 2,
    path: require("../../assets/gallery/3.jpg"),
    span: { base: 2, md: 1 },
  },
  {
    id: 3,
    path: require("../../assets/gallery/4.jpg"),
    span: { base: 5, md: 2 },
  },
  {
    id: 4,
    path: require("../../assets/gallery/5.jpg"),
    span: { base: 2, md: 3 },
  },
  {
    id: 5,
    path: require("../../assets/gallery/6.jpg"),
    span: { base: 3, md: 2 },
  },
  {
    id: 6,
    path: require("../../assets/gallery/7.jpg"),
    span: { base: 3, md: 2 },
  },
  {
    id: 7,
    path: require("../../assets/gallery/8.jpg"),
    span: { base: 2, md: 3 },
  },
  {
    id: 8,
    path: require("../../assets/gallery/9.jpg"),
    span: { base: 2, md: 3 },
  },
  {
    id: 9,
    path: require("../../assets/gallery/10.jpg"),
    span: { base: 3, md: 2 },
  },
];

export default function OurGallery() {
  return (
    <Center id="our-gallery">
      <Grid
        templateRows="repeat(2, 1fr)"
        templateColumns="repeat(5, 1fr)"
        width={"100%"}
        px={{
          base: "1rem",
          md: "2rem",
          lg: "4rem",
          xl: "6rem",
          "2xl": "20rem",
        }}
        my="5rem"
        gap={4}
      >
        <GridItem rowSpan={1} colSpan={2}>
          <Header firstLine="Our" secondLine="Gallery" color="blue" />
        </GridItem>
        {GALLERY_ITEMS.map((item) => {
          return (
            <GridItem key={item.id} colSpan={item.span}>
              <Image
                height={{ base: "10rem", md: "20rem", lg: "30rem" }}
                width="100%"
                borderRadius="md"
                src={item.path}
                objectFit="cover"
                align="center"
              />
            </GridItem>
          );
        })}
      </Grid>
    </Center>
  );
}
